import React from 'react';
import { useHistory } from 'react-router-dom';

import Store from 'store';
import getPrewImage from '../../_utils/preview';
import store from '../../store';
import { MediaQuery, WrapAuto } from '../Common';
import DesignThum from '../designthum/DesignThum';

export const RenderThumbs = ({
  thumbList,
  interest_list,
  largeCount,
  middleCount,
  middleSmallCount,

  main_title,
  onGoFavori,
  ShowBasketModal,
  setStateAsync,
  setData,
}) => {
  const history = useHistory();
  const ShowFavModal = (id) => {
    if (!Store.get('accessToken')) {
      let err = '로그인 후 이용이 가능합니다.';
      if (Store.get('lang') !== 'kr') {
        err = 'You can use it after logging in.';
      }
      alert(err);
      return history.push('/auth');
    }
    const { interest_group, interest_list } = store.getState();

    if (interest_group.length < 1) {
      if (Store.get('lang') === 'kr') {
        alert('관심 그룹이 1개 미만입니다. 관심 상품 페이지로 이동 후, 관심 그룹을 추가해주세요.');
      } else {
        alert(
          'You have less than 1 interest group. After moving to the page of interest products, please add an interest group.',
        );
      }
      return onGoFavori();
    }
    setStateAsync('interestTarget', id);
    setStateAsync('showfavmodal', true);
  };

  const onGoDesigner = (id) => {
    history.push({
      pathname: `/designer/shop/${id}`,
    });
  };

  const onGoDetailView = (id) => {
    history.push({
      pathname: `/design/detail/item/${id}`,
    });
  };
  const setCartInOut = (id) => {
    thumbList.forEach((item) => {
      if (item.product_id === id) {
        // is_in_cart 값이 true면 false로, false면 true로 변경
        item.is_in_cart = !item.is_in_cart;
      }
    });
    setData(thumbList);
  };

  const renderThumbsList = (thumbList, interest_list, count, main_title) => {
    return (
      <>
        {thumbList.slice(0, count).map((item, index) => (
          <DesignThum
            key={`new-${index}`}
            bg={`${process.env.REACT_APP_S3_BUCKET_DOMAIN}${getPrewImage(item.product_preview, 'small')}`}
            license={
              item.vip_krw_price !== null ? 'VIP' : item.license === 'Premium' ? 'Premium' : item.is_sale ? 'Sale' : ''
            }
            productId={item.product_id}
            name={item.product_name}
            designerName={item.user.nickname}
            like={interest_list.includes(item.product_id)}
            is_in_cart={item.is_in_cart}
            onFavClick={() => ShowFavModal(item.product_id)}
            onDesigner={() => onGoDesigner(item.seller_id)}
            ShowBasketModal={ShowBasketModal}
            setCartInOut={setCartInOut}
            onClick={() => {
              onGoDetailView(item.product_id);
            }}
            remove={item.vip_krw_price === null && item.license !== 'Premium' && !item.is_sale}
          />
        ))}
      </>
    );
  };

  return (
    <WrapAuto>
      <MediaQuery min={1200}>{renderThumbsList(thumbList, interest_list, largeCount, main_title)}</MediaQuery>
      <MediaQuery max={1199} min={1000}>
        {renderThumbsList(thumbList, interest_list, middleCount, main_title)}
      </MediaQuery>
      <MediaQuery max={999} min={700}>
        {renderThumbsList(thumbList, interest_list, middleSmallCount, main_title)}
      </MediaQuery>
      <MediaQuery max={699}>{renderThumbsList(thumbList, interest_list, 14, main_title)}</MediaQuery>
    </WrapAuto>
  );
};

export default RenderThumbs;
